"use strict";const r=require("./index-4dcdb00f.js"),i=require("./index-8b6fbbdb.js");function n(e){return i.requiredArgs(1,arguments),r.isSameDay(e,Date.now())}exports.isToday=n;
